import React, {useContext, useEffect} from 'react'
import {dataContext,localestr} from '../utils.js'
import EditCtrl from '../cmp/EditCtrl.js';
import Panel from '../cmp/Panel'

function CatEmployeesEdit({data,actions}){
    let wndData=''
    if(data) wndData=data.wndData
    else wndData=actions.getWndData()
    const setWndData=actions.setWndData
    const tabClose=actions.tabClose

    const context=useContext(dataContext)
    const saveData=context.saveData
    const msg=context.msg

    const setValue=(name,data)=>{
        let newData={...wndData,changed:true}
        if(name==='position') {
            if(data){
                newData.sum_m=data.sum_m
                newData.sum_d=data.sum_d
                newData.sum_h=data.sum_h
                newData.prc_a=data.prc_a
                newData.prc_t=data.prc_t
                newData.department1=data.department1
                newData.prc_d1=data.prc_d1
                newData.department2=data.department2
                newData.prc_d2=data.prc_d2
                newData.taxes=data.taxes
                newData.tax_base=data.tax_base
                newData.expenses=data.expenses
            }
        }
        if (data==='') newData[name]=null
        else newData[name]=data
        setWndData(newData)
    }

    const update=(d)=>{
        //return
        let newData={...wndData,...d.data,changed:false}
        setWndData(newData)
        //tabClose()
    }
    
    const saveValue=(act)=>{
        let errmsg=''
        const name=(wndData.name || '').substring(0,50)
        const code=(wndData.code || '').substring(0,15)
        const start=wndData.start?(new Date(wndData.start)).toISOString().substring(0,10):''
        const finish=wndData.finish?(new Date(wndData.finish)).toISOString().substring(0,10):''
        const position=wndData.position || {id:null,name:null}
        const department=wndData.department || {id:null,name:null}
        const sum_m=wndData.sum_m || ''
        const sum_d=wndData.sum_d || ''
        const sum_h=wndData.sum_h || ''
        const author=wndData.author || {id:null,name:null}
        const prc_a=wndData.prc_a || ''
        const prc_t=wndData.prc_t || ''
        const department1=wndData.department1 || {id:null,name:null}
        const prc_d1=wndData.prc_d1 || ''
        const department2=wndData.department2 || {id:null,name:null}
        const prc_d2=wndData.prc_d2 || ''
        const taxes=wndData.taxes || ''
        const tax_base=wndData.tax_base || ''
        const expenses=wndData.expenses || ''

        if (name===null || name==='') errmsg=localestr("Не заповнено ім'я")
        if (errmsg!=='') msg(errmsg,localestr('Помилка'),[{caption:'OK',action:()=>{}}])
        else{
            let id=wndData.id
            if (id===null || id==='' || id===undefined){
                let newData={status:'add',key:'CatEmployees',data:{name,code,start,finish,position,department,sum_m,sum_d,sum_h,author,prc_a,prc_t,department1,prc_d1,department2,prc_d2,taxes,tax_base,expenses}}
                saveData(newData,d=>{if(wndData.update) wndData.update(d.data);act(d)})
                //почекати ы закрити выкно
            }  
            else if(wndData.changed) {
                let newData={status:'mod',key:'CatEmployees',data:{id,name,code,start,finish,position,department,sum_m,sum_d,sum_h,author,prc_a,prc_t,department1,prc_d1,department2,prc_d2,taxes,tax_base,expenses}}
                saveData(newData,d=>{if(wndData.update) wndData.update(d.data);act(d)})
            }    
            else {
                if(wndData.update) wndData.update({id,name,code,start,finish,position,department,sum_m,sum_d,sum_h,author,prc_a,prc_t,department1,prc_d1,department2,prc_d2,taxes,tax_base,expenses})
                act({id,name,code,start,finish,position,department,sum_m,sum_d,sum_h,author,prc_a,prc_t,department1,prc_d1,department2,prc_d2,taxes,tax_base,expenses})
            }    
        }

    }

    useEffect(() => {
        if (context.data['catEmployees'] === undefined) {
            context.getData('catEmployees')
        } 
    },)

    let tax_cont=null
    if(parseInt(wndData.taxes)) tax_cont=<div style={{margin:'2px 0',display:'inherit',flexDirection:'column'}}>
        <EditCtrl Capt={localestr('База для розрахунку податків (якщо відрізняється від нарахованої зарплати)')} Value={wndData.tax_base} typeVal={'number'} setVal={(d)=>{setValue('tax_base',d)}} width1='508' width2='70'/>
        <EditCtrl Capt={localestr('Ставити податки у витрати (в такому разі вся зарплата йде у виплату)')} Value={wndData.expenses} typeVal={'l_check'} setVal={(d)=>{setValue('expenses',d)}} width1='155' width2='182'/>
    </div>



    return(

    <div style={{display:'flex',flexDirection:'column', margin:'4px 0',alignSelf:'flex-start',flexGrow:'10000'}}>
        <div style={{margin:'2px 0',display:'inherit'}}>
            <EditCtrl Capt={'Id'} Value={wndData.id} typeVal={'text'} setVal={(d)=>{setValue('id',d)}} width1='16' width2='40' disabled={true}/>
            <div style={{minWidth:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
            <EditCtrl Capt={localestr('ПІБ')} Value={wndData.name} typeVal={'text'} setVal={(d)=>{setValue('name',d)}} width1='28' width2='244'/>
            <div style={{minWidth:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
            <div style={{minWidth:'234px',display:'inline-block',flexGrow:234,maxWidth:'368px'}}></div>
        </div>
        <div style={{margin:'2px 0',display:'inherit'}}>
            <EditCtrl Capt={localestr('Прийнятий')} Value={wndData.start} typeVal={'date'} setVal={(d)=>{setValue('start',d)}} width1='84' width2='106'/>
            <div style={{minWidth:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
            <EditCtrl Capt={localestr('Звільнений')} Value={wndData.finish} typeVal={'date'} setVal={(d)=>{setValue('finish',d)}} width1='86' width2='106'/>
            <div style={{minWidth:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
            <EditCtrl Capt={localestr('Бейджик')} Value={wndData.code} typeVal={'text'} setVal={(d)=>{setValue('code',d)}} width1='68' width2='112'/>
        </div>
        <div style={{margin:'2px 0',display:'inherit'}}>
            <EditCtrl Capt={localestr('Посада')} Value={wndData.position} typeVal={'catPositions'} setVal={(d)=>{setValue('position',d)}} width1='54' width2='180'/>
            <div style={{minWidth:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
            <EditCtrl Capt={localestr('Підрозділ')} Value={wndData.department} typeVal={'catDepartments'} setVal={(d)=>{setValue('department',d)}} width1='74' width2='200'/>
        </div>
        <Panel caption={localestr('Нарахування зарплати')} width={580} open={wndData.p_salary===undefined?true:wndData.p_salary} setOpen={d=>setWndData({...wndData,p_salary:d})}>
        <div style={{margin:'2px 0',display:'inherit'}}>
            <EditCtrl Capt={localestr('Місячний оклад')} Value={wndData.sum_m} typeVal={'number'} setVal={(d)=>{setValue('sum_m',d)}} width1='118' width2='70'/>
            <div style={{minWidth:'16px',display:'inline-block',flexGrow:4,maxWidth:'32px'}}></div>
            <EditCtrl Capt={localestr('Денна оплата')} Value={wndData.sum_d} typeVal={'number'} setVal={(d)=>{setValue('sum_d',d)}} width1='102' width2='70'/>
            <div style={{minWidth:'16px',display:'inline-block',flexGrow:4,maxWidth:'32px'}}></div>
            <EditCtrl Capt={localestr('Годинна оплата')} Value={wndData.sum_h} typeVal={'number'} setVal={(d)=>{setValue('sum_h',d)}} width1='116' width2='70'/>
        </div>
        <div style={{margin:'2px 0',display:'inherit'}}>
            <EditCtrl Capt={localestr('Процент виручки користувача')} Value={wndData.prc_a} typeVal={'number'} setVal={(d)=>{setValue('prc_a',d)}} width1='230' width2='66'/>
            <div style={{minWidth:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
            <EditCtrl Capt={localestr('Користувач')} Value={wndData.author} typeVal={'catUsers'} setVal={(d)=>{setValue('author',d)}} width1='84' width2='190'/>
        </div>
        <EditCtrl Capt={localestr('Процент загальної виручки')} Value={wndData.prc_t} typeVal={'number'} setVal={(d)=>{setValue('prc_t',d)}} width1='204' width2='70'/>
        <div style={{margin:'2px 0',display:'inherit'}}>
            <EditCtrl Capt={localestr('Процент виручки підрозділа')+' 1'} Value={wndData.prc_d1} typeVal={'number'} setVal={(d)=>{setValue('prc_d1',d)}} width1='226' width2='70'/>
            <div style={{minWidth:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
            <EditCtrl Capt={localestr('Підрозділ')} Value={wndData.department1} typeVal={'catDepartments'} setVal={(d)=>{setValue('department1',d)}} width1='74' width2='200'/>
        </div>
        <div style={{margin:'2px 0',display:'inherit'}}>
            <EditCtrl Capt={localestr('Процент виручки підрозділа')+' 2'} Value={wndData.prc_d2} typeVal={'number'} setVal={(d)=>{setValue('prc_d2',d)}} width1='226' width2='70'/>
            <div style={{minWidth:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
            <EditCtrl Capt={localestr('Підрозділ')} Value={wndData.department2} typeVal={'catDepartments'} setVal={(d)=>{setValue('department2',d)}} width1='74' width2='200'/>
        </div>
        <EditCtrl Capt={localestr('Нараховувати податки')} Value={wndData.taxes} typeVal={'l_check'} setVal={(d)=>{setValue('taxes',d)}} width1='155' width2='182'/>
        {tax_cont}
        </Panel>
        <div className='no-print' style={{margin:'10px 0 0 0',minWidth:'580px',maxWidth:'1160px',display:'flex',justifyContent:'center',flexGrow:'100000'}}>
        <div style={{width:'60px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{saveValue(tabClose)}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>OK</div></div>
        <div style={{width:'90px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{saveValue(update)}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Зберегти')}</div></div>
        </div>
    </div>
    )
    
}

export default CatEmployeesEdit